var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',{staticClass:"text-h6"},[(_vm.icon)?_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(_vm._s(_vm.cardTitle)+" "),_c('v-spacer'),_vm._t("button")],2),_vm._t("default"),_c('v-card-actions',[_c('v-spacer'),_vm._t("actions")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }